import React from 'react';
import { TagComponent as Tag, Table, Box, Checkbox } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { hasDatePassed, parseStringToDate } from '@epi-helpers/dateHelper';
import { IBeneficiariesRow } from '@epi-models/pages/Beneficiaries';
import { useGetBenefitGroupsQuery } from '@epi-api/benefitGroups';

import {
  CheckboxCell,
  NameCell,
  StyledRow
} from '../BeneficiariesTable.styled';

import { BeneficiaryActions } from './BeneficiaryActions';
import { OverflowTooltip } from '@epi-components/OverflowTooltip/OverflowTooltip';

export const BeneficiariesRow = ({
  showDetail,
  beneficiary,
  groupSetting,
  isSelected,
  onToggleSelect
}: IBeneficiariesRow) => {
  const { t } = useTranslation();
  const { gray70, fontSemiBold } = useTheme();
  const { data: benefitGroups } = useGetBenefitGroupsQuery();
  const benefitGroup = benefitGroups?.find(
    group => group.groupId === beneficiary.groupId
  );
  const endOfFundsDatePassed =
    !!beneficiary.endOfFunds &&
    !!hasDatePassed(parseStringToDate(beneficiary.endOfFunds));

  return (
    <StyledRow key={beneficiary.personId} disabled={endOfFundsDatePassed}>
      <CheckboxCell>
        <Checkbox
          noPadding
          checked={isSelected}
          onChange={() => onToggleSelect(beneficiary.personId)}
          disabled={endOfFundsDatePassed}
        />
      </CheckboxCell>
      <NameCell>
        <Box
          display="flex"
          alignItems="center"
          id="manage-employees-table-employee"
        >
          {beneficiary.lastName} {beneficiary.firstName}
          {beneficiary.isNew && (
            <Box
              lineHeight="11px"
              ml={2}
              id="manage-employees-table-employee-new-label"
            >
              <Tag label={t('containers.beneficiaries.table.new')} size="s" />
            </Box>
          )}
          {endOfFundsDatePassed && (
            <Box
              lineHeight="11px"
              ml={2}
              id="manage-employees-table-employee-remove-label"
            >
              <Tag
                label={t('containers.beneficiaries.table.remove')}
                size="s"
                color={gray70}
                borderColor={gray70}
                fontWeight={fontSemiBold}
              />
            </Box>
          )}
        </Box>
      </NameCell>
      <Table.Cell id="manage-employees-table-email">
        {beneficiary.emailAddress}
      </Table.Cell>
      <Table.Cell id="manage-employees-table-email">
        {t(`containers.beneficiaries.detail.${beneficiary.employmentType}`)} (
        {beneficiary.benefitPercentage}%)
      </Table.Cell>
      <Table.Cell id="manage-employees-table-benefit-group">
        <Box maxWidth={240}>
          <OverflowTooltip title={benefitGroup?.groupName}>
            <span>{benefitGroup?.groupName}</span>
          </OverflowTooltip>
        </Box>
      </Table.Cell>
      <Table.Cell align="left">
        <BeneficiaryActions
          beneficiary={beneficiary}
          endOfFundsDatePassed={endOfFundsDatePassed}
          showDetail={showDetail}
          groupSetting={groupSetting}
        />
      </Table.Cell>
    </StyledRow>
  );
};
